import React, { useState, useEffect, useRef, useMemo } from "react"
import { sum } from "lodash"
import { Bar } from "react-chartjs-2"
import Leitura from "components/shared/Util/leitura"
//import ReactExport from "react-export-excel";
import { Button, Card, CardBody, Col, Row, Form, Input as RSInput } from "reactstrap"
import Input from "components/shared/Inputs/Inputs"
import Select from "react-select"
import Swal from "sweetalert2"
import api from "../../../services/api"
import AuthService from "../../../services/Auth.service"
import { Link } from "react-router-dom"
import "./barchart.css"

//const ExcelFile = ReactExport.ExcelFile;
//const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
//const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
//
const initialData = [
  {
    MES: "",
    MAIORPULSO: "",
    MENORPULSO: "",
    DEVICE: "",
    NR_HIDROMETRO: "",
    IDA: "",
    DS_LOCALIDADE: "",
  },
  {
    MES: "",
    MAIORPULSO: "",
    MENORPULSO: "",
    DEVICE: "",
    NR_HIDROMETRO: "",
    IDA: "",
    DS_LOCALIDADE: "",
  },
]

const initialData2 = [
  {
    MES: "",
    MAIORPULSO: "",
    MENORPULSO: "",
    DEVICE: "",
    NR_HIDROMETRO: "",
    IDA: "",
    DS_LOCALIDADE: "",
  },
]

function BarChart() {
  const DASH_CACHE_TTL_MS = 5 * 60 * 1000
  const dashboardCacheRef = useRef({})

  const readCache = key => {
    const entry = dashboardCacheRef.current[key]
    if (!entry) return null
    if (Date.now() - entry.ts > DASH_CACHE_TTL_MS) return null
    return entry.data
  }

  const writeCache = (key, data) => {
    dashboardCacheRef.current[key] = {
      ts: Date.now(),
      data,
    }
  }

  //Busca Medidores

  const initialState = {
    maker: "",
    desc: "",
    model: "",
    number: "",
  }

  const Empresa = {
    OID_EMPRESA: "",
    NM_RAZAO_SOCIAL: "",
  }
  const Empresa2 = {
    id: "",
    label: "",
  }

  const [searchm, setSearchm] = useState(initialState)
  let [makers, setMakers] = useState([])
  const [condos, setCondo] = useState([])
  let [lc, setLc] = useState(Empresa)
  let [setcondo, setsetcondo] = useState(Empresa2)
  let [setcondo2, setsetcondo2] = useState(Empresa2)
  const [gateways, setGateways] = useState([])
  let stateempresa = null
  const user = AuthService.getCurrentUser()

  let checkempresa = null
  let DS_STATUS = null
  if (user != null) {
    DS_STATUS = user.user.DS_STATUS
    if (user.empresa[0] != undefined) {
      checkempresa = user.empresa[0].OID_EMPRESA
    }
  }
  const isAdmin = Number(DS_STATUS) === 10

  const fetchMakers = () => {
    let maker = [{ maker: "Selecione..." }]
    api.get("/imovel/hidro/" + user.user.OID_USUARIO).then(response => {
      response.data.map(elem => {
        maker.push({
          id: elem.NR_MEDIDOR,
          maker: "Medidor: " + elem.NR_MEDIDOR + " - " + elem.imovel,
        })
      })
      setMakers(maker)
    })
  }

  const fetchCondo = () => {
    let condo = [{ id: "", condo: "Selecione..." }]
    api.get("/empresa/").then(response => {
      response.data.map(elem => {
        condo.push({
          id: elem.OID_EMPRESA,
          condo: elem.NM_RAZAO_SOCIAL,
        })
      })
      setCondo(condo)
    })
  }

  useEffect(() => {
    fetchMakers()
  }, [])

  //if(DS_STATUS == 10){
  useEffect(() => {
    fetchCondo()
  }, [])
  // }

  const onChangeCondo = prop => event => {
    setLc({ ...lc, [prop]: event.target.value })

    stateempresa = event.target.value

    fetchHidroCondo()
  }

  const fetchHidroCondo = () => {
    let maker = [{ maker: "Selecione..." }]
    api.get("/imovel/empresa/" + stateempresa).then(response => {
      response.data.map(elem => {
        maker.push({
          id: elem.NR_MEDIDOR,
          maker: "Medidor: " + elem.NR_MEDIDOR + " - " + elem.imovel,
        })
      })
      setMakers(maker)
    })
  }

  //Busca Medidores

  const [showInfos, setShowInfos] = useState([])
  const [reseta, setReseta] = useState([])
  const [showDisplay, setShowDisplay] = useState("none")
  const [showPulse, setShowPulse] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState(initialData)
  const [data2, setData2] = useState(initialData2)
  const [search, setSearch] = useState({
    ida: undefined,
    hydro: undefined,
    dateInit: "",
    dateEnd: "",
  })
  const [typeHidro, setTypeHidro] = useState({
    ativo: 0,
    inativo: 0,
  })

  const [localidade, setLocalidade] = useState([])
  const [hidrometro, setHidrometro] = useState("")
  const [ida, setIda] = useState("")
  const [values, setValues] = useState([])
  const [mes, setMes] = useState([])
  //const [mes, setMes] = useState(new Set());
  const [day, setDay] = useState(false)
  const [filter, setFilter] = useState(false)
  const [values2, setValues2] = useState([])
  const [mes2, setMes2] = useState([])
  const [device, setDevice] = useState([])
  const [here, setHere] = useState(1)
  const [total2, setTotal2] = useState([])
  const [EquipmentsDMAE, setEquipmentsDMAE] = useState([])
  const [total, setTotal] = useState("")
  const [titleAlarm, setTitleAlarm] = useState("")
  const [titleAlarmTipe, setTitleAlarmTipe] = useState("")
  const [alarmFilterType, setAlarmFilterType] = useState("")
  const [isMeter, setIsMeter] = useState(false)
  const [isLora, setIsLora] = useState(false)
  const [init, setInit] = useState(false)
  const [dataLora, setDataLora] = useState([])
  const [typeEquip, setTypeEquip] = useState("")
  const [showLocation, setShowLocation] = useState("")
  const [filterCondominio, setfilterCondominio] = useState("")
  const [zeradoSortCol, setZeradoSortCol] = useState("dias")
  const [zeradoSortDir, setZeradoSortDir] = useState("desc")

  const [isAlarme, setIsAlarme] = useState(false)
  const [isSemConsumo, setIsSemConsumo] = useState(false)

  // Degradê da borda direita da tabela (mobile): precisa sumir ao chegar no fim
  // da rolagem, senão sinaliza "tem mais conteúdo" quando já não tem. Só o JS
  // sabe a posição do scroll — o ::after que desenha o degradê é cego a isso.
  const [semConsumoNoFim, setSemConsumoNoFim] = useState(false)

  const handleSemConsumoScroll = e => {
    const el = e.currentTarget
    // A tolerância de 1px cobre o arredondamento sub-pixel de zoom/DPI, que
    // impede scrollLeft + clientWidth de bater exatamente em scrollWidth.
    setSemConsumoNoFim(el.scrollLeft + el.clientWidth >= el.scrollWidth - 1)
  }

  const [filteredShowInfos, setfilteredShowInfos] = useState([])
  const [filteredZeradosShowInfos, setFilteredZeradosShowInfos] = useState([])
  const [zeradoDias, setZeradoDias] = useState({})
  const [loadingDias, setLoadingDias] = useState(false)

  const [loadingcorte, setLoadingcorte] = useState(true)
  const [loadingmeter, setLoadingmeter] = useState(true)

  let uniqueEmpresas = []
  let filtereddata = []

  if (showInfos.length > 0) {
    uniqueEmpresas = [...new Set(showInfos.map(info => info.empresa))]
  }

  // let filteredShowInfos = [];

  useEffect(() => {
    // Inside the effect, perform the filtering logic
    let filteredData = []

    if (isLora || isSemConsumo || isAlarme) {
      if (showInfos.length > 0) {
        filteredData = filterCondominio
          ? showInfos.filter(info => info.empresa === filterCondominio)
          : showInfos
      }
    } else {
      filteredData = showInfos
    }

    // Update the state using setFilteredShowInfos
    setfilteredShowInfos(filteredData)

    // Ensure that the effect runs only when dependencies change
  }, [showInfos, filterCondominio])

  const [meter, setMeter] = useState({
    h_24: 0,
    h_12: 0,
    zer: 0,
    h_3: 0,
    calibrar: 0,
  })
  const [alarm, setAlarm] = useState({
    total: 0,
    corte: 0,
    vazamento: 0,
    ataque_magnetico: 0,
    reverso: 0,
    zerado: 0,
  })

  const [loraType, setLoraType] = useState({
    vinculado: 0,
    disponivel: 0,
  })

  const [vistoriasNecessarias, setVistoriasNecessarias] = useState(0)
  const [loadingVistorias, setLoadingVistorias] = useState(true)
  const vistoriaRef = useRef(null)

  // useEffect(() => {
  //    alarms();
  //    loras2();
  //    meters();
  //   // hidrometerType();
  // }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setLoadingmeter(true)
      setLoadingcorte(true)
      alarms()
      loras2()
      meters()
      // hidrometerType();
    }, 3600000) // 90 seconds in milliseconds

    // Run the functions immediately when the component mounts
    alarms()
    loras2()
    meters()
    // hidrometerType();
    if (isAdmin) {
      fetchVistorias()
    }

    return () => clearInterval(intervalId)
  }, [])

  // Fetch vistoria data for the dashboard warning
  const fetchVistorias = async () => {
    try {
      setLoadingVistorias(true)
      // Busca todos os condominios
      const response = await api.get("/empresa/")
      const condominios = response.data || []
      const hoje = new Date()
      let count = 0

      // Para cada condomínio, busca a data de vistoria
      await Promise.all(
        condominios.map(async item => {
          try {
            const dateResponse = await api.get(
              `/empresa/installation-date/${item.OID_EMPRESA}`,
            )
            const dateData = Array.isArray(dateResponse.data)
              ? dateResponse.data[0]
              : dateResponse.data
            const vistoriaDate = dateData?.DT_ULT_VISTORIA || null

            if (!vistoriaDate) {
              count++
            } else {
              const dt = new Date(vistoriaDate)
              const prazo = new Date(dt)
              prazo.setMonth(prazo.getMonth() + 6)
              if (prazo < hoje) count++
            }
          } catch {
            count++ // Se falhar ao buscar, conta como necessário
          }
        }),
      )

      setVistoriasNecessarias(count)
    } catch (e) {
      console.error("Erro ao buscar vistorias:", e)
    } finally {
      setLoadingVistorias(false)
    }
  }

  // Flashing effect for vistoria warning
  useEffect(() => {
    if (vistoriasNecessarias > 0) {
      const intervalVistoria = setInterval(() => {
        if (vistoriaRef.current) {
          if (vistoriaRef.current.style.color === "red") {
            vistoriaRef.current.style.color = "#495057"
          } else {
            vistoriaRef.current.style.color = "red"
          }
        }
      }, 2000)
      return () => clearInterval(intervalVistoria)
    }
  }, [vistoriasNecessarias])

  function resetSearch() {
    setShowInfos([])
    resetStates()
    setShowPulse("")
    setTotal("")
    setSearch({
      ida: "",
      hydro: "",
      dateInit: "",
      dateEnd: "",
    })
    setIsLora(false)
    setIsAlarme(false)
    setIsSemConsumo(false)
    setTitleAlarm("")
    setTitleAlarmTipe("")
    setAlarmFilterType("")
    setfilterCondominio("")

    setfilteredShowInfos([])
  }
  function resetStates() {
    let resettotal = null
    setIsLoading(true)
    setShowDisplay("none")
    setLocalidade([])
    setHidrometro("")
    setIda("")
    let reset2 = mes.splice(0, mes.length)
    let reset = values.splice(0, values.length)
    // setValues([]);
    // setMes([]);
    setValues([])
    setMes([])
    setMes2([])
    setTotal("")

    setValues2([])
    setDevice([])
    setDay(false)
    setFilter(false)
    setIsLora(false)
    setIsAlarme(false)
    setIsSemConsumo(false)
    setAlarmFilterType("")
  }
  const alarms = async () => {
    const cacheKey = `alarm:GERAL:${DS_STATUS}:${checkempresa}`
    const cached = readCache(cacheKey)
    const payload = cached
      ? cached
      : await api
          .post("/consumptions/alarm", {
            TYPE: "GERAL",
            DS_STATUS: DS_STATUS,
            OID_EMPRESA: checkempresa,
          })
          .then(response => response.data)

    if (!cached) {
      writeCache(cacheKey, payload)
    }

    let pulso = 0
    let valvula =
      parseInt(payload[0].valvula_1) +
      parseInt(payload[0].valvula_2) +
      parseInt(payload[0].valvula_3) +
      parseInt(payload[0].valvula_4)
    let reverso =
      parseInt(payload[0].reverso_1) +
      parseInt(payload[0].reverso_2) +
      parseInt(payload[0].reverso_3) +
      parseInt(payload[0].reverso_4)
    let totalAlarm =
      pulso + payload[0].status_da_valvula + payload[0].ataque_magnetico
    let zerado =
      parseInt(payload[0].zerado_1) +
      parseInt(payload[0].zerado_2) +
      parseInt(payload[0].zerado_3) +
      parseInt(payload[0].zerado_4)

    setAlarm({
      total: totalAlarm,
      corte: pulso,
      vazamento: valvula,
      ataque_magnetico: payload[0].ataque_magnetico,
      reverso: reverso,
      zerado: zerado,
    })
    setLoadingcorte(false)
  }

  const meters = async () => {
    const cacheKey = "meters:GERAL:HOUR"
    const cached = readCache(cacheKey)
    const payload = cached
      ? cached
      : await api
          .post("/consumptions/meters", {
            TYPE: "GERAL",
            HOUR: "HOUR",
          })
          .then(response => response.data)

    if (!cached) {
      writeCache(cacheKey, payload)
    }

    setMeter({
      h_24: payload[0].meters24,
      h_12: payload[0].meters12,
      zer: payload[0].zerado,
      h_3: 0,
      calibrar: payload[0].calibragem,
    })
    if (payload[0].calibragem > 0) {
      setInterval(() => {
        console.log(meter.calibrar)
        if (elementRef.current) {
          if (elementRef.current.style.color == "red") {
            elementRef.current.style.color = "#495057"
          } else {
            elementRef.current.style.color = "red"
          }
        }
      }, 2000)
    }
    setLoadingmeter(false)
  }
  const hidrometerType = async () => {
    await api
      .post("/consumptions/hidrometer", {
        TYPE: "FULL",
      })
      .then(response => {
        setTypeHidro({
          ativo: response.data[0].ATIVOS,
          inativo: response.data[0].INATIVOS,
        })
      })
  }
  useEffect(() => {
    api.get("/registrosportas").then(response => {
      let arr = []
      arr = response.data

      setEquipmentsDMAE(arr)
      for (let i = 0; i < arr.length; i++) {
        if (
          arr[i].NR_MEDIDOR === hidrometro &&
          Number(arr[i].DS_RELOJOARIA_INICIAL) !== null
        ) {
          console.log("arr" + arr[i].DS_RELOJOARIA_INICIAL)
          setTotal2(Number(arr[i].DS_RELOJOARIA_INICIAL))
          //  setTotal2(Number(arr[i].DS_RELOJOARIA_INICIAL));
        }
      }
    })
  }, [hidrometro])
  const showMeters = async filter => {
    setfilterCondominio("")
    let titulo = ""
    if (filter == "24h") {
      titulo = "Módulos sem consumo 24h"
    }
    if (filter == "ZERADO") {
      titulo = "Módulos com Pulso Zerado"
    }
    if (filter == "CALIBRAR") {
      titulo = "Módulos que precisam ser calibrados"
    }
    const cacheKey = `meters:detail:${filter}:${checkempresa ?? "all"}`
    const cached = readCache(cacheKey)
    const data = cached
      ? cached
      : await api
          .post("/consumptions/meters", {
            HOUR: filter,
            TYPE: "",
            OID_EMPRESA: checkempresa,
          })
          .then(response => response.data)

    if (!cached) {
      writeCache(cacheKey, data)
    }

    setShowInfos(data)
    setIsAlarme(false)
    setIsLora(false)
    setIsSemConsumo(true)
    setShowDisplay("block")
    setTitleAlarm(titulo)
    setTitleAlarmTipe("")

    if (filter == "ZERADO" && data.length > 0) {
      setLoadingDias(true)
      const diasKey = "meters:zerado-dias"
      const cachedDias = readCache(diasKey)
      if (cachedDias) {
        setZeradoDias(cachedDias)
        setLoadingDias(false)
      } else {
        setZeradoDias({})
        api
          .post("/consumptions/meters/zerado-dias")
          .then(diasResponse => {
            const diasMap = {}
            diasResponse.data.forEach(item => {
              diasMap[item.modulo] = item.dias_zerado
            })
            writeCache(diasKey, diasMap)
            setZeradoDias(diasMap)
          })
          .catch(err => console.error("Erro ao buscar dias zerado:", err))
          .finally(() => setLoadingDias(false))
      }
    }
  }

  const getDiasZerados = item => {
    if (zeradoDias[item.modulo] != null) {
      return Number(zeradoDias[item.modulo])
    }
    return Math.floor((item.leituras_consecutivas_zerado || 0) / 4)
  }

  const toggleZeradoSort = column => {
    if (zeradoSortCol === column) {
      setZeradoSortDir(prev => (prev === "asc" ? "desc" : "asc"))
      return
    }
    setZeradoSortCol(column)
    setZeradoSortDir("asc")
  }

  const getSortIndicator = column => {
    const isActive = zeradoSortCol === column
    const upOpacity = isActive && zeradoSortDir === "asc" ? 1 : 0.3
    const downOpacity = isActive && zeradoSortDir === "desc" ? 1 : 0.3
    return (
      <span style={{ marginLeft: 4, fontSize: "0.7em", whiteSpace: "nowrap" }}>
        <span style={{ opacity: upOpacity }}>▲</span>
        <span style={{ opacity: downOpacity }}>▼</span>
      </span>
    )
  }

  const sortedShowInfos = useMemo(() => {
    return [...filteredShowInfos].sort((a, b) => {
      if (titleAlarm.includes("Pulso Zerado")) {
        let compare = 0

        if (zeradoSortCol === "condominio") {
          compare = (a.empresa || "").localeCompare(b.empresa || "", "pt-BR")
        } else if (zeradoSortCol === "dias") {
          compare = getDiasZerados(a) - getDiasZerados(b)
        } else if (zeradoSortCol === "data") {
          compare =
            new Date(a.DT_GRAVACAO_REG || 0).getTime() -
            new Date(b.DT_GRAVACAO_REG || 0).getTime()
        }

        if (compare === 0) {
          compare = (a.modulo || "").localeCompare(b.modulo || "", "pt-BR")
        }

        return zeradoSortDir === "asc" ? compare : -compare
      }

      const dateA = new Date(a.DT_GRAVACAO_REG)
      const dateB = new Date(b.DT_GRAVACAO_REG)
      return dateA - dateB
    })
  }, [filteredShowInfos, titleAlarm, zeradoSortCol, zeradoSortDir, zeradoDias])

  useEffect(() => {
    if (titleAlarm.includes("Pulso Zerado")) {
      if (Object.keys(zeradoDias).length > 0) {
        const filtered = sortedShowInfos.filter(item => {
          const dias = zeradoDias[item.modulo]
          return dias == null || dias >= 10
        })
        setFilteredZeradosShowInfos(filtered)
      } else {
        setFilteredZeradosShowInfos(sortedShowInfos)
      }
    }
  }, [titleAlarm, sortedShowInfos, zeradoDias])

  //reverso ou vazamento no pulso
  const isReversoGrid =
    alarmFilterType === "REVERSO" || alarmFilterType === "VAZAMENTO"

  const showTypeHidro = async filter => {
    await api
      .post("/consumptions/hidrometer", {
        TYPE: filter,
      })
      .then(response => {
        setShowInfos(response.data)
        setShowDisplay("block")
        if (filter == "ATIVOS") {
          setTitleAlarm("Hidrometros Ativos")
        } else if (filter == "INATIVOS") {
          setTitleAlarm("Hidrometros Inativos")
        }
        setTitleAlarmTipe("")
      })
  }
  const showAlarms = async filter => {
    await api
      .post("/consumptions/alarm", {
        TYPE: filter,
        DS_STATUS: DS_STATUS,
        OID_EMPRESA: checkempresa,
      })
      .then(response => {
        setShowInfos(response.data)
        setIsAlarme(true)
        setIsSemConsumo(false)
        setShowDisplay("block")
        setAlarmFilterType(filter)
        setTitleAlarm("Alarmes das ultimas 24 horas --> ")
        if (filter == "CORTE") {
          setTitleAlarmTipe("Corte de cabo do Pulso")
        } else if (filter == "VAZAMENTO") {
          setTitleAlarmTipe("Vazamento no Pulso")
        } else if (filter == "ATAQUE") {
          setTitleAlarmTipe("Ataque Magnético")
        } else if (filter == "REVERSO") {
          setTitleAlarmTipe("Consumo Reverso")
        } else if (filter == "ZERADO") {
          setTitleAlarmTipe("Consumo Zerado")
        } else if (filter == "CALIBRAGEM") {
          setTitleAlarmTipe("Calibragem Necessaria")
        }
      })
  }

  const showLoras2 = async filter => {
    await api
      .post("/consumptions/alarm/lora", {
        TYPE: filter,
        DS_STATUS: DS_STATUS,
        OID_EMPRESA: checkempresa,
      })
      .then(response => {
        setShowInfos(response.data)
        setShowDisplay("block")
        setIsLora(true)
        setIsAlarme(true)
        setIsSemConsumo(false)

        if (filter == "vinculados") {
          setTitleAlarm("Loras Com Registro na rede Lora")
        } else if (filter == "disponiveis") {
          setTitleAlarm("Loras Sem Registro na rede Lora")
        }
      })
  }

  const formatTime = hours => {
    if (hours > 4) {
      return ""
    }

    const totalMinutes = Math.floor(hours * 60)
    const totalSeconds = Math.floor(hours * 3600)

    const years = Math.floor(hours / (24 * 365))
    const remainingHoursAfterYears = hours % (24 * 365)
    const months = Math.floor(remainingHoursAfterYears / (24 * 30))
    const remainingHoursAfterMonths = remainingHoursAfterYears % (24 * 30)
    const days = Math.floor(remainingHoursAfterMonths / 24)
    const remainingHoursAfterDays = Math.floor(remainingHoursAfterMonths % 24)
    const minutes = Math.floor((hours % 1) * 60)

    let formatted = ""

    if (years > 0) formatted += `${years} ano${years > 1 ? "s" : ""}, `
    if (months > 0) formatted += `${months} mês${months > 1 ? "es" : ""}, `
    if (days > 0) formatted += `${days} dia${days > 1 ? "s" : ""}, `
    if (remainingHoursAfterDays > 0)
      formatted += `${remainingHoursAfterDays} hora${
        remainingHoursAfterDays > 1 ? "s" : ""
      }, `
    if (minutes > 0) formatted += `${minutes} minuto${minutes > 1 ? "s" : ""}`
    if (!formatted) formatted = "1 minuto"

    return formatted.trim().replace(/,\s*$/, "")
  }

  const loras2 = async () => {
    await api
      .get("/gateway/alarmes")
      .then(response => {
        setGateways(response.data)
      })
      .catch(error => {
        console.error("Erro ao buscar gateways:", error)
      })

    await api
      .post("/consumptions/alarm/lora", {
        TYPE: "GERAL",
        DS_STATUS: DS_STATUS,
        OID_EMPRESA: checkempresa,
      })
      .then(response => {
        let vinculado = parseInt(response.data[0].vinculados)
        let disponivel = parseInt(response.data[0].disponiveis)
        let ultimo_envio = parseInt(response.data[0].ultimo_envio)
        let ultimo_recebimento = parseInt(response.data[0].ultimo_recebimento)

        setLoraType({
          vinculado: vinculado,
          disponivel: disponivel,
          ultimo_envio: ultimo_envio,
          ultimo_recebimento: ultimo_recebimento,
        })
      })
  }

  const loras = async () => {
    await api.get("/equipmentslora/linked", {}).then(response => {
      setDataLora({
        vinculado: response.data.linked,
        disponivel: response.data.notLinked,
      })
      setLoraType({
        vinculado: response.data.countLinked,
        disponivel: response.data.countNotLinked,
      })
    })
  }

  const showLoras = async filter => {
    setTypeEquip("lora")
    if (filter == "vinculados") {
      setShowInfos(dataLora.vinculado)
      setShowLocation("Localização")
      setTitleAlarm("Loras Vinculados")
      setIsLora(false)
    } else {
      setShowInfos(dataLora.disponivel)
      setTitleAlarm("Loras Disponíveis")
      setIsLora(true)

      setShowLocation("")
    }
    setShowDisplay("block")
    setIsMeter(false)
  }

  const showHidro = async idHidro => {
    setHidrometro(idHidro.target.innerHTML)
    setSearch({
      ida: undefined,
      hydro: idHidro.target.innerHTML,
    })
    submitHandler(idHidro.target.innerHTML)
  }

  useEffect(() => {
    let intArray = values.map(str => parseInt(str))
    setValues2(intArray)
  }, [values])

  const submitHandlerPrevent = async event => {
    event.preventDefault()

    setValues([])
    setMes([])
    // let reset = 2;
    // setReseta(reset)
    // setValues([], () => {

    //   submitHandler();
    // });

    submitHandler()
  }
  const submitHandler = async idHidro => {
    // if (typeof idHidro == 'string') {

    //   search.hydro = idHidro;
    // }
    if (hidrometro !== undefined || ida !== undefined) {
      await api
        .post("/consumptions/draw", {
          NR_HIDROMETRO: day ? hidrometro : search.hydro,
          // NR_HIDROMETRO: "Y22G601060 - PL1/2b028f15",
          IDA: search.ida,
          TYPE: "MES",
          DATE: {
            start: search.dateInit ? search.dateInit : "",
            end: search.dateEnd ? search.dateEnd : "",
          },
        })
        .then(response => {
          var d = ""
          let oldValue = 0
          var lastMax = 0
          setReseta(oldValue)
          var k = 0
          resetStates()
          let sumPulse = 0
          let countMes = ""
          for (var i = 0; i < response.data.length; i++) {
            // if (typeof response.data[i].menorpulso == "undefined") {
            //   response.data[i].menorpulso = 0;
            // }
            // if (typeof response.data[i].maiorpulso == "undefined") {
            //   response.data[i].maiorpulso = 0;
            // }
            response.data[i].menorpulso = Math.trunc(
              response.data[i].menorpulso,
            )
            response.data[i].maiorpulso = Math.trunc(
              response.data[i].maiorpulso,
            )
            if (i === 0) {
              countMes = response.data[i].mes
              sumPulse =
                sumPulse +
                (response.data[i].maiorpulso - response.data[i].menorpulso)
              //console.log("0-"+response.data[i].maiorpulso - response.data[i].menorpulso)

              if (!search.dateInit) {
                let parts = response.data[i].mes.split("/")
                response.data[i].mes = `${parts[1]}/${parts[0]}`
              } else {
                let parts = response.data[i].mes.split("/")
                response.data[i].mes = `${parts[2]}/${parts[1]}`
              }

              let newArraymes = [...mes, response.data[i].mes]
              setMes(oldState => [...oldState, newArraymes])
              // let mes2 = mes.push(response.data[i].mes)
              // setMes(mes2);
              let newArray = [
                parseInt(
                  response.data[i].maiorpulso - response.data[i].menorpulso,
                ),
              ]
              setValues(oldState => [...oldState, newArray])
              //  setValues(newArray)
              // setValues(
              //   response.data[i].maiorpulso - response.data[i].menorpulso,
              // );

              //let values2 = values.push(response.data[i].maiorpulso - response.data[i].menorpulso);
              //setValues(values2)
              //setValues([values.concat(new Array(1).fill([response.data[i].maiorpulso - response.data[i].menorpulso]))]);
              // concat(new Array(1).fill([result.length+1,result[0].idEquipDmae])
              // setValues([...values, response.data[i].maiorpulso - response.data[i].menorpulso]);
              lastMax = response.data[i].maiorpulso

              if (countMes == response.data[i].mes) {
                setHidrometro(response.data[i].nr_hidrometro)
                setIda(response.data[i].ds_localidade)
                setLocalidade(response.data[i].ds_localidade)
              } else {
                setHidrometro(response.data[i].nr_hidrometro)
                setIda(response.data[i].ds_localidade)
                setLocalidade(response.data[i].ds_localidade)
              }
            } else {
              console.log("else" + response.data[i].maiorpulso)
              const dataFiltered = data.slice(0, 2)
              setData(dataFiltered)

              if (!search.dateInit) {
                let parts = response.data[i].mes.split("/")
                response.data[i].mes = `${parts[1]}/${parts[0]}`
              } else {
                let parts = response.data[i].mes.split("/")
                response.data[i].mes = `${parts[2]}/${parts[1]}`
              }

              let newArraymes = [...mes, response.data[i].mes]
              setMes(oldState => [...oldState, newArraymes])
              oldValue = response.data[i].menorpulso - lastMax
              sumPulse =
                sumPulse +
                (response.data[i].maiorpulso - response.data[i].menorpulso)

              let newArray = [
                parseInt(
                  response.data[i].maiorpulso - response.data[i].menorpulso,
                ),
              ]
              setValues(oldState => [...oldState, newArray])
              // setValues(newArray)

              // setValues((oldState) => [
              //   ...oldState,
              //   (response.data[i].maiorpulso - response.data[i].menorpulso + oldValue),
              // ]);

              // this.setState({
              //   values:[...this.state.values, newArray]
              // });
              // setValues([values.concat(new Array(1).fill([response.data[i].maiorpulso - response.data[i].menorpulso + oldValue]))]);
              // let values2 = values.concat(response.data[i].maiorpulso - response.data[i].menorpulso);
              //setValues(values2)
              //values = values.concat(new Array(1).fill([response.data[i].maiorpulso - response.data[i].menorpulso + oldValue]));
              //setValues([values.concat(response.data[i].maiorpulso - response.data[i].menorpulso + oldValue)]);
              // setValues((oldState) => [
              //   ...oldState,
              //   (response.data[i].maiorpulso - response.data[i].menorpulso + oldValue),
              // ]);
              // setValues(prevSet => new Set(prevSet.add(response.data[i].maiorpulso - response.data[i].menorpulso + oldValue)));

              //    setValues(
              //   (response.data[i].maiorpulso - response.data[i].menorpulso + oldValue)
              // );
              lastMax = response.data[i].maiorpulso
            }

            // setMes(prevSet => new Set(prevSet.add(response.data[i].mes)));
            //console.log("mes"+response.data[i].mes)
            //setMes((oldState) => [...oldState, response.data[i].mes]);
            // let mes2 = mes.concat(response.data[i].mes)
            //   setMes(mes2);
            setHere(1)
            // if (total === "") {
            setTotal(sumPulse)

            if (k > 0) {
              d = response.data[i]
              setData2(oldState => [...oldState, d])
            } else {
              d = response.data[i]
              setData(oldState => [...oldState, d])
              setIsLoading(false)
            }
          }
          search.dateInit ? setShowPulse(sumPulse) : ""
          search.dateInit ? setDay(false) : ""
          search.dateInit ? setFilter(true) : ""
        })
        .catch(error => {
          resetStates()

          let resp = error.response.data.split("*")
          Swal.fire({
            title: resp[1],
            icon: "warning",
          })
        })
    }
  }
  const showDay = async filter => {
    //console.log("Filter"+filter)
    let m = filter.toString()
    let parts = m.substring(0, 2)
    // let month = parts[0];
    await api
      .post("/consumptions/draw", {
        NR_HIDROMETRO: hidrometro,
        IDA: ida,
        TYPE: "DAY",
        MES: parts,
      })
      .then(response => {
        var d = ""
        let oldValue = 0
        var lastMax = 0
        var k = 0
        resetStates()
        let sumPulse = 0
        let countMes = ""

        for (var i = 0; i < response.data.length; i++) {
          if (typeof response.data[i].menorpulso == "undefined") {
            response.data[i].menorpulso = 0
          }
          response.data[i].menorpulso = Math.trunc(response.data[i].menorpulso)
          response.data[i].maiorpulso = Math.trunc(response.data[i].maiorpulso)
          if (i === 0) {
            response.data[i].menorpulso = Math.trunc(
              response.data[i].menorpulso,
            )
            response.data[i].maiorpulso = Math.trunc(
              response.data[i].maiorpulso,
            )
            countMes = response.data[i].mes
            sumPulse =
              sumPulse +
              (response.data[i].maiorpulso - response.data[i].menorpulso)
            // let mes2 = mes.push(response.data[i].mes)
            // let mes3 = mes.concat(mes2)
            //   setMes(mes3);

            // let parts = response.data[i].mes.split("/");
            //     response.data[i].mes =  `${parts[1]}/${parts[0]}`;
            let parts = response.data[i].mes.split("/")
            response.data[i].mes = `${parts[1]}/${parts[0]}`

            let newArraymes = [...mes, response.data[i].mes]
            setMes(oldState => [...oldState, newArraymes])

            let newArray = [
              parseInt(
                response.data[i].maiorpulso - response.data[i].menorpulso,
              ),
            ]
            setValues(oldState => [...oldState, newArray])
            //   let values2 = values.push(response.data[i].maiorpulso - response.data[i].menorpulso );
            // let values3 = values.concat(values2);

            //   setValues(values3)
            // setValues((oldState) => [
            //   ...oldState,
            //   response.data[i].maiorpulso - response.data[i].menorpulso,
            // ]);
            lastMax = response.data[i].maiorpulso

            if (countMes == response.data[i].mes) {
              setHidrometro(response.data[i].nr_hidrometro)
              setIda(response.data[i].ds_localidade)
              setLocalidade(response.data[i].ds_localidade)
            } else {
              setHidrometro(response.data[i].nr_hidrometro)
              setIda(response.data[i].ds_localidade)
              setLocalidade(response.data[i].ds_localidade)
            }
          } else {
            const dataFiltered = data.slice(0, 2)
            setData(dataFiltered)
            console.log("dias" + [i] + response.data[i].mes)
            console.log(
              "valordia" +
                [i] +
                response.data[i].maiorpulso -
                response.data[i].menorpulso,
            )
            oldValue = lastMax - response.data[i].menorpulso
            sumPulse =
              sumPulse +
              (response.data[i].maiorpulso -
                response.data[i].menorpulso +
                oldValue)

            let parts = response.data[i].mes.split("/")
            response.data[i].mes = `${parts[1]}/${parts[0]}`

            let newArray = [
              parseInt(
                response.data[i].maiorpulso - response.data[i].menorpulso,
              ),
            ]
            setValues(oldState => [...oldState, newArray])

            //  let parts = response.data[i].mes.split("/");
            //     response.data[i].mes =  `${parts[1]}/${parts[0]}`;

            let newArraymes = [...mes, response.data[i].mes]
            setMes(oldState => [...oldState, newArraymes])
            // setValues((values2) => [
            //   ...values2
            // ]);
            lastMax = response.data[i].maiorpulso
          }

          // let mes2 = mes.concat(response.data[i].mes)
          //     setMes(mes2);
          // setMes((oldState) => [...oldState, response.data[i].mes]);
          setHere(2)

          if (k > 0) {
            d = response.data[i]
            setData2(oldState => [...oldState, d])
          } else {
            d = response.data[i]
            setData(oldState => [...oldState, d])
            setIsLoading(false)
            setDay(true)
          }
        }
        search.dateInit ? setShowPulse(sumPulse) : ""
      })
      .catch(error => {
        let resp = error.response.data.split("*")
        Swal.fire({
          title: resp[1],
          icon: "warning",
        })
      })
  }
  const onChangeHandler = prop => event => {
    setSearch(oldState => ({ ...oldState, [prop]: event.target.value }))
  }

  const onChangeHandlerm = prop => event => {
    setSearchm({ ...search, [prop]: event.target.value })
    //console.log(search)
  }

  //console.log("valuesfim"+values)
  //console.log("mesfim"+mes)
  const newData = [0, ...values2]
  // intArray = values.map((str) => parseInt(str))
  const chartData = {
    labels: mes,
    // labels: ['2023/01', '2023/02'],
    datasets: [
      {
        label: "teste", //this.state.data[0]?.DEVICE,
        backgroundColor: "rgb(0, 87, 170)",
        borderColor: "rgb(0, 87, 170)",
        borderWidth: 1,
        hoverBackgroundColor: "rgb(0, 87, 170)",
        hoverBorderColor: "rgb(0, 87, 170)",
        // data: [3, 7],
        data: values2,
        //total: 0,
        total: sum(values2).toFixed(2),
      },
    ],
  }

  const option = {
    tootlbar: {
      show: false,
    },

    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },

    legend: {
      display: false,
    },

    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex]
          var total = dataset.total
          var currentValue = dataset.data[tooltipItem.index]
          var percentage = parseFloat(((currentValue / total) * 100).toFixed(1))
          return currentValue + " (" + percentage + "%)"
        },
        title: function (tooltipItem, data) {
          return data.labels[tooltipItem[0].index]
        },
      },
    },
    onClick: function (event, element) {
      if (element.length == 0) {
      } else {
        if (day == false && filter == false) {
          showDay(element[0]._model.label)
        }
      }
    },
  }

  //console.log(showInfos)

  const elementRef = useRef(null)
  /*
    useEffect(() => {
      const intervalIdCalib = setInterval(() => {
        console.log(meter.calibrar)
         if (elementRef.current && meter.calibrar > 0) {
          if ( elementRef.current.style.color == 'red') {
            elementRef.current.style.color = '#495057';
          } else {
            elementRef.current.style.color = 'red';
          }
        }
      }, 2000);

      /*if (meter.calibrar == 0) {
        elementRef.current.style.color = 'black';

        return () => clearInterval(intervalId);

      }*
    }, []); */

  return (
    <>
      {isLoading ? (
        <>
          {showDisplay == "none" ? (
            <>
              <div style={{}}>
                {(() => {
                  if (isAdmin) {
                    return (
                      <div style={{}}>
                        <div
                          className="col-md-12"
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                            borderRadius: 5,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                              backgroundColor: "#CEEBEF",
                            }}
                          >
                            <div
                              className="font-size-18 col-md-12"
                              style={{
                                fontWeight: "bold",
                                fontSize: "xx-large",
                              }}
                            >
                              Retornos
                            </div>
                          </div>

                          <div>
                            <div
                              style={{
                                borderWidth: 0.1,
                                borderStyle: "solid",
                                borderColor: "#F6F6F8",

                                minWidth: 250,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  padding: 15,
                                }}
                                // onClick={() => showLoras2("disponiveis")}
                              >
                                <div style={{ fontWeight: "bold" }}>
                                  Ultimo envio para o Dmae
                                </div>
                                <div>
                                  {formatTime(
                                    parseInt(loraType.ultimo_envio, 10),
                                  )}{" "}
                                  {loraType &&
                                    (loraType.ultimo_envio < 24 ? (
                                      <span className="badge bg-success">
                                        On
                                      </span>
                                    ) : (
                                      <span className="badge bg-danger bg-primary">
                                        Off
                                      </span>
                                    ))}
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                borderWidth: 0.1,
                                borderStyle: "solid",
                                borderColor: "#F6F6F8",

                                minWidth: 250,
                              }}
                              // onClick={() => showLoras2("vinculados")}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  padding: 15,
                                }}
                              >
                                <div style={{ fontWeight: "bold" }}>
                                  Ultimo recebimento da Syskeeper
                                </div>
                                <div>
                                  {formatTime(
                                    parseInt(loraType.ultimo_recebimento, 10),
                                  )}{" "}
                                  {loraType &&
                                    (loraType.ultimo_recebimento < 24 ? (
                                      <span className="badge bg-success">
                                        On
                                      </span>
                                    ) : (
                                      <span className="badge bg-danger bg-primary">
                                        Off
                                      </span>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                })()}
                {/* <div
                  style={{
                    borderWidth: 0.1,
                    borderStyle: "solid",
                    borderColor: "#F6F6F8",
                    borderRadius: 5,
                    width: 350,
                  }}
                >
                  <div
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      padding: 15,
                      backgroundColor: "#CEEBEF",
                    }}
                  >
                    <div
                      className="font-size-18 col-md-12"
                      style={{ fontWeight: "bold", width: 350 }}
                    >
                      Medidores
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        borderWidth: 0.1,
                        borderStyle: "solid",
                        borderColor: "#F6F6F8",
                        width: 350,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          padding: 15,
                        }}
                        onClick={() => showMeters("24h")}
                      >
                        <div style={{ fontWeight: "bold" }}>Sem Consumo 24 Horas</div>
                        <div>{meter.h_24}</div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        borderWidth: 0.1,
                        borderStyle: "solid",
                        borderColor: "#F6F6F8",
                        width: 350,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          padding: 15,
                        }}
                        onClick={() => showMeters("12h")}
                      >
                        <div style={{ fontWeight: "bold" }}>Sem Consumo 12 Horas</div>
                        <div>{meter.h_12}</div>
                      </div>
                    </div>
                  </div>


                </div> */}

                <div
                  style={{ display: "flex", width: "100%", flexWrap: "wrap" }}
                >
                  <div
                    className=""
                    style={{
                      borderWidth: 0.1,
                      borderStyle: "solid",
                      borderColor: "#F6F6F8",
                      borderRadius: 5,
                      flex: "1 1 250px",
                      minWidth: 250,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        padding: 15,
                        backgroundColor: "#CEEBEF",
                      }}
                    >
                      <div
                        className="font-size-18 col-md-12"
                        style={{ fontWeight: "bold" }}
                      >
                        Alarmes das ultimas 24 horas
                      </div>
                    </div>

                    <div>
                      <div
                        style={{
                          borderWidth: 0.1,
                          borderStyle: "solid",
                          borderColor: "#F6F6F8",

                          minWidth: 250,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            padding: 15,
                            cursor: "pointer",
                          }}
                          // onClick={() => showAlarms("CORTE")}
                          onClick={() => showAlarms("CORTE")}
                        >
                          <div style={{ fontWeight: "bold" }}>
                            Corte de Cabo do Pulso
                          </div>
                          <div>
                            {loadingcorte ? (
                              <i className="mdi mdi-spin mdi-loading"></i>
                            ) : (
                              <div>{/* {alarm.corte} */}0</div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          borderWidth: 0.1,
                          borderStyle: "solid",
                          borderColor: "#F6F6F8",

                          minWidth: 250,
                        }}
                        onClick={() => showAlarms("VAZAMENTO")}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            padding: 15,
                            cursor: "pointer",
                          }}
                        >
                          <div style={{ fontWeight: "bold" }}>
                            Possível Vazamento
                          </div>

                          {loadingcorte ? (
                            <i className="mdi mdi-spin mdi-loading"></i>
                          ) : (
                            <div>{alarm.vazamento}</div>
                          )}
                        </div>
                      </div>

                      <div
                        style={{
                          borderWidth: 0.1,
                          borderStyle: "solid",
                          borderColor: "#F6F6F8",
                          minWidth: 250,
                        }}
                        onClick={() => showAlarms("ATAQUE")}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            padding: 15,
                            cursor: "pointer",
                          }}
                        >
                          <div style={{ fontWeight: "bold" }}>
                            Ataque Magnético
                          </div>

                          {loadingcorte ? (
                            <i className="mdi mdi-spin mdi-loading"></i>
                          ) : (
                            <div>{alarm.ataque_magnetico}</div>
                          )}
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                            minWidth: 250,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                              cursor: "pointer",
                            }}
                            onClick={() => showAlarms("REVERSO")}
                          >
                            <div style={{ fontWeight: "bold" }}>
                              Consumo Reverso
                            </div>

                            {loadingcorte ? (
                              <i className="mdi mdi-spin mdi-loading"></i>
                            ) : (
                              <div>{alarm.reverso}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {(() => {
                    if (isAdmin) {
                      return (
                        <div
                          className=""
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                            borderRadius: 5,
                            minWidth: 250,
                            flex: "1 1 250px",
                          }}
                        >
                          <div
                            style={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                              backgroundColor: "#CEEBEF",
                            }}
                          >
                            <div
                              className="font-size-18 col-md-12"
                              style={{ fontWeight: "bold" }}
                            >
                              Medidores
                            </div>
                          </div>
                          {/* <div>
                    <div
                      style={{
                        borderWidth: 0.1,
                        borderStyle: "solid",
                        borderColor: "#F6F6F8",
                        minWidth: 250,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          padding: 15,
                          cursor:"pointer"
                        }}
                         onClick={() => showMeters("12h")}
                      >
                        <div style={{ fontWeight: "bold" }}>Sem Consumo 12 Horas</div>
                        <div>{meter.h_12}</div>
                      </div>
                    </div>
                  </div> */}
                          <div>
                            <div
                              style={{
                                borderWidth: 0.1,
                                borderStyle: "solid",
                                borderColor: "#F6F6F8",
                                minWidth: 250,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  padding: 15,
                                  cursor: "pointer",
                                }}
                                onClick={() => showMeters("24h")}
                              >
                                <div style={{ fontWeight: "bold" }}>
                                  Sem Consumo 24 Horas
                                </div>
                                <div>
                                  {loadingmeter ? (
                                    <i className="mdi mdi-spin mdi-loading"></i>
                                  ) : (
                                    <div>{meter.h_24}</div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div>
                            <div
                              style={{
                                borderWidth: 0.1,
                                borderStyle: "solid",
                                borderColor: "#F6F6F8",
                                minWidth: 250,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  padding: 15,
                                  cursor: "pointer",
                                }}
                                onClick={() => showMeters("ZERADO")}
                              >
                                <div style={{ fontWeight: "bold" }}>
                                  Pulso Zerado
                                </div>
                                <div>
                                  {loadingmeter ? (
                                    <i className="mdi mdi-spin mdi-loading"></i>
                                  ) : (
                                    <div>{meter.zer}</div>
                                  )}
                                </div>{" "}
                              </div>
                            </div>
                          </div>

                          <div>
                            <div
                              style={{
                                borderWidth: 0.1,
                                borderStyle: "solid",
                                borderColor: "#F6F6F8",
                                minWidth: 250,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  padding: 15,
                                  cursor: "pointer",
                                }}
                                onClick={() => showMeters("CALIBRAR")}
                              >
                                <div
                                  ref={elementRef}
                                  style={{ fontWeight: "bold" }}
                                >
                                  Calibragem Necessária
                                </div>

                                {loadingmeter ? (
                                  <i className="mdi mdi-spin mdi-loading"></i>
                                ) : (
                                  <div>{meter.calibrar}</div>
                                )}
                              </div>
                            </div>
                          </div>

                          {isAdmin && (
                            <div>
                              <div
                                style={{
                                  borderWidth: 0.1,
                                  borderStyle: "solid",
                                  borderColor: "#F6F6F8",
                                  minWidth: 250,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    padding: 15,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    window.location.href = "/cadastro/vistorias"
                                  }}
                                >
                                  <div
                                    ref={vistoriaRef}
                                    style={{ fontWeight: "bold" }}
                                  >
                                    Vistoria Necessária
                                  </div>
                                  {loadingVistorias ? (
                                    <i className="mdi mdi-spin mdi-loading"></i>
                                  ) : (
                                    <div>{vistoriasNecessarias}</div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )
                    }
                  })()}
                </div>

                {isAdmin && (
                  <div
                    className="col-md-12"
                    style={{
                      borderWidth: 0.1,
                      borderStyle: "solid",
                      borderColor: "#F6F6F8",
                      borderRadius: 5,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        padding: 15,
                        backgroundColor: "#CEEBEF",
                      }}
                    >
                      <div
                        className="font-size-18 col-md-12"
                        style={{ fontWeight: "bold", fontSize: "xx-large" }}
                      >
                        GateWays
                      </div>
                    </div>

                    {gateways.map((gateway, idx) => {
                      const { DS_NOME, DS_CODIGO, TIPO, total_hours } = gateway
                      const hours = parseInt(total_hours)

                      return (
                        <div
                          key={idx}
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                            minWidth: 250,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                          >
                            <div>
                              <div style={{ fontWeight: "bold" }}>
                                {DS_NOME}
                              </div>
                              <div style={{ fontSize: "small", color: "#666" }}>
                                {TIPO}
                              </div>
                            </div>

                            <div>
                              {formatTime(hours)}{" "}
                              {hours < 4 ? (
                                <span className="badge bg-success">On</span>
                              ) : (
                                <>
                                  <span>{hours} horas </span>
                                  <span className="badge bg-danger">Off</span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )}

                {/* {
                  (() => {
                    if (isAdmin) {
                      return <div style={{}}>
                        <div
                          className="col-md-12"
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                            borderRadius: 5,

                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                              backgroundColor: "#CEEBEF",
                            }}
                          >
                            <div
                              className="font-size-18 col-md-12"
                              style={{ fontWeight: "bold", fontSize: "xx-large" }}
                            >
                              Loras
                            </div>
                          </div>

                          <div>
                            <div
                              style={{
                                borderWidth: 0.1,
                                borderStyle: "solid",
                                borderColor: "#F6F6F8",

                                minWidth: 250,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  padding: 15,
                                }}
                                onClick={() => showLoras2("disponiveis")}
                              >
                                <div style={{ fontWeight: "bold" }}>
                                  Sem registro na rede Lora
                                </div>
                                <div>{loraType.disponivel}</div>
                              </div>
                            </div>
                            <div
                              style={{
                                borderWidth: 0.1,
                                borderStyle: "solid",
                                borderColor: "#F6F6F8",

                                minWidth: 250,
                              }}
                              onClick={() => showLoras2("vinculados")}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  padding: 15,
                                }}
                              >
                                <div style={{ fontWeight: "bold" }}>
                                  Com Registro na rede Lora
                                </div>
                                <div>{loraType.vinculado}</div>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                    }
                  })()
                } */}
              </div>

              {/* <div style={{ display: "flex" }}>
                <div
                  className="col-md-12"
                  style={{
                    borderWidth: 0.1,
                    borderStyle: "solid",
                    borderColor: "#F6F6F8",
                    borderRadius: 5,
                    width: 350,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      padding: 15,
                      backgroundColor: "#CEEBEF",
                    }}
                  >
                    <div
                      className="font-size-18 col-md-12"
                      style={{ fontWeight: "bold" }}
                    >
                      HIDROMETROS
                    </div>
                  </div>

                  <div>
                    <div
                      style={{
                        borderWidth: 0.1,
                        borderStyle: "solid",
                        borderColor: "#F6F6F8",
                        width: 350,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          padding: 15,
                        }}
                        onClick={() => showTypeHidro("ATIVOS")}
                      >
                        <div style={{ fontWeight: "bold" }}>
                          Ativos
                        </div>
                        <div>{typeHidro.ativo}</div>
                      </div>
                    </div>
                    <div
                      style={{
                        borderWidth: 0.1,
                        borderStyle: "solid",
                        borderColor: "#F6F6F8",
                        width: 350,
                      }}
                      onClick={() => showTypeHidro("INATIVOS")}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          padding: 15,
                        }}
                      >
                        <div style={{ fontWeight: "bold" }}>
                          Inativos
                        </div>
                        <div>{typeHidro.inativo}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </>
          ) : (
            <></>
          )}
          <div style={{ display: showDisplay }}>
            <div>
              <span className="font-weight-bold font-size-18 h2 mt-4 card-title">
                {titleAlarm}
              </span>
              <span className="font-weight-normal card-title">
                {titleAlarmTipe}
              </span>
            </div>

            <div className="col-sm-12 mb-2 card-title d-flex justify-content-end">
              {/* <ExcelFile
                style={{ display: showDisplay }}
                className="d-flex justify-content-center"
              >
                <ExcelSheet data={showInfos} name="Localizações">
                  <ExcelColumn label="HIDROMETRO" value="HIDROMETRO" />
                  <ExcelColumn label="ENDEREÇO" value="LOCALIDADE" />
                </ExcelSheet>
              </ExcelFile> */}

              <button className="btn btn-link ml-2" onClick={resetSearch}>
                Voltar
              </button>
            </div>

            {isAlarme && (
              <>
                {
                  <Row className="" style={{ paddingBottom: "15px" }}>
                    <label
                      htmlFor="oid_condo_alarme"
                      className="col-md-2 col-form-label"
                    >
                      Condominio
                    </label>
                    <div className="col-md-6">
                      <Select
                        inputId="oid_condo_alarme"
                        classNamePrefix="select"
                        placeholder="Selecione o condomínio..."
                        isClearable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                        }}
                        options={uniqueEmpresas.map(e => ({
                          value: e,
                          label: e,
                        }))}
                        value={
                          filterCondominio
                            ? {
                                value: filterCondominio,
                                label: filterCondominio,
                              }
                            : null
                        }
                        onChange={opt =>
                          setfilterCondominio(opt ? opt.value : "")
                        }
                      />
                    </div>
                  </Row>
                }

                <div
                  className="table-responsive"
                  style={{
                    overflowX: "auto",
                    maxHeight: "calc(100vh - 300px)",
                    overflowY: "auto",
                  }}
                >
                  <table
                    className="table align-middle table-nowrap mb-0"
                    style={{
                      minWidth: "1200px",
                    }}
                  >
                    <thead
                      className="table-light"
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                      }}
                    >
                      <tr>
                        {isLora ? (
                          ""
                        ) : (
                          <th className="align-middle">Medidor</th>
                        )}
                        {isLora ? (
                          <th className="align-middle">Condomínio</th>
                        ) : (
                          <th className="align-middle">Localização</th>
                        )}
                        {isReversoGrid && (
                          <th className="align-middle">Condomínio</th>
                        )}
                        <th className="align-middle">Módulo</th>
                        {titleAlarm.includes("Pulso Zerado") && (
                          <th className="align-middle">Dias Zerados</th>
                        )}
                        {titleAlarm.includes("Pulso Zerado") && (
                          <th className="align-middle">Sem Morador</th>
                        )}

                        {isLora ? <th className="align-middle">Status</th> : ""}
                      </tr>
                    </thead>
                    <tbody>
                      {(titleAlarm.includes("Pulso Zerado")
                        ? filteredZeradosShowInfos
                        : sortedShowInfos
                      )?.map((element, key) => (
                        <tr key={"_tr_" + key}>
                          {isLora ? "" : <td>{element.hidrometro}</td>}
                          {isLora ? (
                            <td>
                              {element.empresa
                                ? element.empresa
                                : "Sem Condomínio Registrado"}{" "}
                            </td>
                          ) : (
                            <td>{element.localidade} </td>
                          )}
                          {isReversoGrid && (
                            <td>
                              {element.empresa
                                ? element.empresa
                                : "Sem Condomínio Registrado"}
                            </td>
                          )}
                          <td>
                            {element.modelo ? (
                              element.modelo
                            ) : isAdmin ? (
                              <span>
                                {" "}
                                {element.modulo}
                                <Link
                                  to={`/calibragem/${element.modulo}?empresa=${element.OID_EMPRESA || checkempresa}`}
                                >
                                  <i className="mdi mdi-exit-to-app"></i>
                                </Link>
                              </span>
                            ) : (
                              <span>{element.modulo}</span>
                            )}
                          </td>
                          {titleAlarm.includes("Pulso Zerado") && (
                            <td>
                              <strong>
                                {loadingDias ? (
                                  <i className="mdi mdi-spin mdi-loading"></i>
                                ) : zeradoDias[element.modulo] != null ? (
                                  zeradoDias[element.modulo] >= 30 ? "30+" : zeradoDias[element.modulo]
                                ) : (
                                  getDiasZerados(element)
                                )}
                              </strong>
                            </td>
                          )}
                          {titleAlarm.includes("Pulso Zerado") && (
                            <td>
                              <RSInput
                                type="switch"
                                id={`sem-morador-${key}`}
                                checked={element.IN_SEM_MORADOR === true}
                                onChange={async () => {
                                  try {
                                    const newValue = !element.IN_SEM_MORADOR;
                                    await api.patch(
                                      `/hydrometers/${element.OID_MEDIDOR}/sem-morador`,
                                      { IN_SEM_MORADOR: newValue },
                                    );
                                    const updatedList = (titleAlarm.includes("Pulso Zerado")
                                      ? filteredZeradosShowInfos
                                      : sortedShowInfos
                                    ).map((item) =>
                                      item.OID_MEDIDOR === element.OID_MEDIDOR || item.modulo === element.modulo
                                        ? { ...item, IN_SEM_MORADOR: newValue }
                                        : item
                                    );
                                    if (titleAlarm.includes("Pulso Zerado")) {
                                      setFilteredZeradosShowInfos(updatedList);
                                    } else {
                                      setfilteredShowInfos(updatedList);
                                    }
                                  } catch (error) {
                                    console.error('Error updating sem morador:', error);
                                  }
                                }}
                              />
                            </td>
                          )}

                          {isLora ? (
                            <td>
                              {" "}
                              {element.retorno > 0 ? (
                                <span className="badge bg-success">
                                  Registrado
                                </span>
                              ) : (
                                <span className="badge bg-danger bg-primary">
                                  Não Registrado
                                </span>
                              )}
                            </td>
                          ) : (
                            ""
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {isSemConsumo && (
              <>
                <Row className="" style={{ paddingBottom: "15px" }}>
                  <label
                    htmlFor="oid_condo"
                    className="col-md-2 col-form-label"
                  >
                    Condominio
                  </label>
                  <div className="col-md-6">
                    <Select
                      inputId="oid_condo"
                      classNamePrefix="select"
                      placeholder="Selecione o condomínio..."
                      isClearable
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      options={uniqueEmpresas.map(e => ({ value: e, label: e }))}
                      value={
                        filterCondominio
                          ? { value: filterCondominio, label: filterCondominio }
                          : null
                      }
                      onChange={opt => setfilterCondominio(opt ? opt.value : "")}
                    />
                  </div>
                </Row>

                {/* Pai posicionado só para ancorar o degradê da borda direita
                    (ver .sem-consumo-scroll-wrap no barchart.css). Precisa ser
                    externo ao container de scroll: um ::after lá dentro rolaria
                    junto com o conteúdo em vez de ficar na borda visível. */}
                <div
                  className={
                    titleAlarm.includes("Pulso Zerado")
                      ? ""
                      : `sem-consumo-scroll-wrap${
                          semConsumoNoFim ? " sem-consumo-scroll-wrap--fim" : ""
                        }`
                  }
                >
                <div
                  className={`table-responsive sem-consumo-scroll${
                    titleAlarm.includes("Pulso Zerado")
                      ? ""
                      : " sem-consumo-scroll-24h"
                  }`}
                  onScroll={
                    titleAlarm.includes("Pulso Zerado")
                      ? undefined
                      : handleSemConsumoScroll
                  }
                >
                  <table
                    className={`table align-middle table-nowrap mb-0 sem-consumo-table${
                      titleAlarm.includes("Pulso Zerado") ? "" : " sem-consumo-24h"
                    }`}
                  >
                    <thead
                      className="table-light"
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                      }}
                    >
                      <tr>
                        <th className="align-middle">Módulo</th>

                        {isLora ? (
                          <th className="align-middle">Condomínio</th>
                        ) : (
                          <th className="align-middle">Localização</th>
                        )}

                        <th
                          className="align-middle"
                          role={titleAlarm.includes("Pulso Zerado") ? "button" : undefined}
                          style={titleAlarm.includes("Pulso Zerado") ? { cursor: "pointer" } : undefined}
                          onClick={
                            titleAlarm.includes("Pulso Zerado")
                              ? () => toggleZeradoSort("condominio")
                              : undefined
                          }
                        >
                          Condomínio{titleAlarm.includes("Pulso Zerado") && getSortIndicator("condominio")}
                        </th>
                        {titleAlarm.includes("Pulso Zerado") && (
                          <th
                            className="align-middle"
                            role="button"
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleZeradoSort("dias")}
                          >
                            Dias Zerados{getSortIndicator("dias")}
                          </th>
                        )}
                        {titleAlarm.includes("Pulso Zerado") && (
                          <th className="align-middle">Sem Morador</th>
                        )}
                        <th
                          className="align-middle"
                          role={titleAlarm.includes("Pulso Zerado") ? "button" : undefined}
                          style={titleAlarm.includes("Pulso Zerado") ? { cursor: "pointer" } : undefined}
                          onClick={
                            titleAlarm.includes("Pulso Zerado")
                              ? () => toggleZeradoSort("data")
                              : undefined
                          }
                        >
                          Data{titleAlarm.includes("Pulso Zerado") && getSortIndicator("data")}
                        </th>
                        <th className="align-middle">Hora</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(titleAlarm.includes("Pulso Zerado")
                        ? filteredZeradosShowInfos
                        : sortedShowInfos
                      )?.map((element, key) => (
                        <tr key={"_tr_" + key}>
                          <td>
                            {element.modelo ? (
                              element.modelo
                            ) : isAdmin ? (
                              <span>
                                {" "}
                                {element.modulo}
                                <Link
                                  to={`/calibragem/${element.modulo}?empresa=${element.OID_EMPRESA || checkempresa}`}
                                >
                                  <i className="mdi mdi-exit-to-app"></i>
                                </Link>
                              </span>
                            ) : (
                              <span>{element.modulo}</span>
                            )}
                          </td>

                          {isLora ? (
                            <td>{element.empresa} </td>
                          ) : titleAlarm.includes("Pulso Zerado") ? (
                            <td>{element.IMOVEL || element.localidade}</td>
                          ) : (
                            <td>{element.IMOVEL} </td>
                          )}
                          <td>{element.empresa}</td>
                          {titleAlarm.includes("Pulso Zerado") && (
                            <td>
                              <strong>
                                {loadingDias ? (
                                  <i className="mdi mdi-spin mdi-loading"></i>
                                ) : zeradoDias[element.modulo] != null ? (
                                  zeradoDias[element.modulo] >= 30 ? "30+" : zeradoDias[element.modulo]
                                ) : (
                                  getDiasZerados(element)
                                )}
                              </strong>
                            </td>
                          )}
                          {titleAlarm.includes("Pulso Zerado") && (
                            <td>
                              <RSInput
                                type="switch"
                                id={`sem-morador-list2-${key}`}
                                checked={element.IN_SEM_MORADOR === true}
                                onChange={async () => {
                                  try {
                                    const newValue = !element.IN_SEM_MORADOR;
                                    await api.patch(
                                      `/hydrometers/${element.OID_MEDIDOR}/sem-morador`,
                                      { IN_SEM_MORADOR: newValue },
                                    );
                                    const updatedList = (titleAlarm.includes("Pulso Zerado")
                                      ? filteredZeradosShowInfos
                                      : filteredShowInfos
                                    ).map((item) =>
                                      item.OID_MEDIDOR === element.OID_MEDIDOR || item.modulo === element.modulo
                                        ? { ...item, IN_SEM_MORADOR: newValue }
                                        : item
                                    );
                                    if (titleAlarm.includes("Pulso Zerado")) {
                                      setFilteredZeradosShowInfos(updatedList);
                                    } else {
                                      setfilteredShowInfos(updatedList);
                                    }
                                  } catch (error) {
                                    console.error('Error updating sem morador:', error);
                                  }
                                }}
                              />
                            </td>
                          )}
                          <td>
                            {element.DT_GRAVACAO_REG !== null ? (
                              <>
                                <span className="data-desktop">
                                  {new Date(
                                    element.DT_GRAVACAO_REG,
                                  ).toLocaleDateString("pt-BR", {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  })}
                                </span>
                                <span className="data-mobile">
                                  {new Date(
                                    element.DT_GRAVACAO_REG,
                                  ).toLocaleDateString("pt-BR", {
                                    year: "2-digit",
                                    month: "2-digit",
                                    day: "2-digit",
                                  })}
                                </span>
                              </>
                            ) : (
                              ""
                            )}
                          </td>

                          <td>
                            {element.DT_GRAVACAO_REG !== null
                              ? new Date(
                                  element.DT_GRAVACAO_REG,
                                ).toLocaleString("pt-BR", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                })
                              : ""}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                </div>
              </>
            )}
          </div>
        </>
      ) : (
        <>
          {day ? (
            <>
              <div className="col-sm-12 mb-2 card-title d-flex justify-content-end">
                <button className="btn btn-link ml-2" onClick={submitHandler}>
                  Voltar
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="col-sm-12 mb-2 card-title d-flex justify-content-end">
                <button className="btn btn-link ml-2" onClick={resetSearch}>
                  Voltar
                </button>
              </div>
            </>
          )}

          <Row className="justify-content-center">
            <Col sm={4}>
              <div className="text-center">
                <h5 className="mb-0 font-size-20">{ida}</h5>
                <p className="text-muted">Condominio</p>
              </div>
            </Col>
            <Col sm={4}>
              <div className="text-center">
                <h5 className="mb-0 font-size-20">{hidrometro}</h5>
                <p className="text-muted">HIDROMETRO</p>
              </div>
            </Col>
            {/* <Col sm={4}>
              <div className="text-center">
                <h5 className="mb-0 font-size-20">{localidade}</h5>
                <p className="text-muted">Endereço</p>
              </div>
            </Col> */}
          </Row>
          <Bar width={600} height={245} data={chartData} options={option} />
        </>
      )}
      <Leitura />
    </>
  )
}

export default BarChart
